import React, { useState, useEffect } from 'react';
import { Card, Table, Statistic, Row, Col, Spin, message } from 'antd';
import dayjs from 'dayjs';
import { getMonthlyTrend } from '../../api/reports';
import { formatMoney } from '../../utils/money';
import { dateSorter, numberSorter } from '../../utils/tableSorters';

const MonthlyTrendTab = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMonthlyTrend()
      .then(res => setData(res.data))
      .catch(() => message.error('Trend raporu yüklenemedi.'))
      .finally(() => setLoading(false));
  }, []);

  // 12 satirlik liste, tamami bellekte - istemci siralayicilari dogru calisir.
  const columns = [
    {
      title: 'Ay',
      dataIndex: 'month',
      sorter: dateSorter('month'),
      render: v => dayjs(v).format('MMMM YYYY'),
    },
    {
      title: 'Yeni Kayıt',
      dataIndex: 'new_enrollments',
      align: 'center',
      sorter: numberSorter('new_enrollments'),
      render: v => <span className="text-blue-600 font-medium">{v}</span>,
    },
    { title: 'Yeni Öğrenci', dataIndex: 'new_students', align: 'center', sorter: numberSorter('new_students') },
    {
      title: 'Aktif Öğrenci',
      dataIndex: 'active_students',
      align: 'center',
      sorter: numberSorter('active_students'),
      render: v => <span className="font-medium">{v}</span>,
    },
    {
      title: 'Tahsilat',
      dataIndex: 'revenue',
      align: 'right',
      sorter: numberSorter('revenue'),
      render: v => <span className="text-green-600 font-medium">{formatMoney(v)}</span>,
    },
  ];

  if (loading) return <div className="text-center p-8"><Spin /></div>;

  const totalRevenue  = data?.reduce((s, r) => s + parseFloat(r.revenue), 0) || 0;
  const totalEnrolled = data?.reduce((s, r) => s + r.new_enrollments, 0) || 0;

  return (
    <div>
      <Row gutter={16} className="mb-4">
        <Col span={8}>
          <Card size="small">
            <Statistic
              title="Son 12 Ay Tahsilat"
              value={totalRevenue.toFixed(2)}
              suffix="₺"
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card size="small">
            <Statistic title="Son 12 Ay Yeni Kayıt" value={totalEnrolled} />
          </Card>
        </Col>
      </Row>

      <Table
        dataSource={data || []}
        rowKey="month"
        columns={columns}
        size="small"
        pagination={false}
      />
    </div>
  );
};

export default MonthlyTrendTab;
